import Vue from 'vue';
import { has, includes } from 'lodash';

import { handleError } from '@/utils/exception_handler';

// STATE
export const updateState = {
  updating: [],
};

// GETTERS
export const updateGetters = {
  updating: state => state.updating,
  isUpdating: (state, getters) => id => includes(getters.updating, id),
};

// MUTATIONS
export const buildUpdateMutations = (mutationNames) => {
  const mutations = {};

  mutationNames.forEach((mutation) => {
    mutations[`${mutation}Pending`] = (state, id) => {
      Vue.set(state, 'updating', state.updating.concat(id));
    };

    mutations[`${mutation}Success`] = (state, id) => {
      Vue.set(state, 'updating', state.updating.filter(itemId => (
        itemId !== id
      )));
    };

    mutations[`${mutation}Error`] = (state, { id }) => {
      Vue.set(state, 'updating', state.updating.filter(itemId => (
        itemId !== id
      )));
    };
  });

  return mutations;
};

// ACTIONS
export const update = (context, { api, endpoint, params, id = null, mutation = null, ormAction = 'update', successCallback = null, errorCallback = null }) => {
  const { commit, dispatch } = context;

  const entityId = id || params.id;
  const mutationPrefix = mutation || endpoint;

  if (!has(api, endpoint)) throw new Error(`Endpoint ${endpoint} not found`);

  // Pending mutation
  if (includes(mutationPrefix, '/')) {
    commit(`${mutationPrefix}Pending`, [entityId], { root: true });
  } else {
    commit(`${mutationPrefix}Pending`, [entityId]);
  }

  return api[endpoint](params)
    .then((response) => {
      // ORM Action
      if (ormAction === 'update') {
        dispatch('update', response.entity);
      } else if (ormAction === 'insert') {
        dispatch('insert', { data: response.entity });
      } else if (ormAction === 'delete') {
        dispatch('delete', response.entity.id);
      }

      // Success mutation
      if (includes(mutationPrefix, '/')) {
        commit(`${mutationPrefix}Success`, null, { root: true });
      } else {
        commit(`${mutationPrefix}Success`);
      }

      if (successCallback) successCallback(response);

      return { status: true, data: response };
    }, handleError(context, `${mutationPrefix}Error`, errorCallback))
    .catch(handleError(context, `${mutationPrefix}Error`, errorCallback));
};



// WEBPACK FOOTER //
// ./src/store/extensions/update.js